import { APAdjustmentParameterDto } from './ap-adjustment-parameter-dto';

export class APAdjustmentEditorForApplyPaymentWithAPCMParameterDto extends APAdjustmentParameterDto {
    vendorCode: string;
    apPaymentId: number;

    getQueryString(): string {
        let queryString = super.getQueryString();
        queryString += `&vendorCode=${this.vendorCode}`;
        queryString += `&apPaymentId=${this.apPaymentId}`;

        return queryString;
    }
}
